import React from "react";
import { useAppSelector } from "../../../hooks/customReduxHooks";
import { useTheme } from "styled-components";
import { DefaultSliderContenedor, ContenedorTitulo, } from "./DefaultSliderStyled";
import TituloSeccion from "../../common/TituloSeccion";
import SliderManager from "../../../modules/SliderManager/SliderManager";
var DefaultSlider = function (_a) {
    var productos = _a.productos, titulo = _a.titulo, descripcion = _a.descripcion, descripcionSeo = _a.descripcionSeo, vinculo = _a.vinculo, className = _a.className, customSettings = _a.customSettings;
    var globalConfig = useAppSelector(function (state) { return state.empresa && state.empresa.globalConfig; });
    var theme = useTheme();
    var defaultSettings = {
        autoplay: "pause",
        perPage: globalConfig.sliderNovedades.media1140,
        perMove: globalConfig.sliderNovedades.media1140,
        gap: theme.separacion,
        padding: {
            right: "calc(".concat(theme.separacion, " - 1px)"),
            left: "calc(".concat(theme.separacion, " - 1px)"),
        },
        breakpoints: {
            479: {
                perPage: globalConfig.sliderNovedades.media479,
                perMove: globalConfig.sliderNovedades.media479,
            },
            719: {
                perPage: globalConfig.sliderNovedades.media719,
                perMove: globalConfig.sliderNovedades.media719,
            },
            919: {
                perPage: globalConfig.sliderNovedades.media919,
                perMove: globalConfig.sliderNovedades.media919,
            },
            1140: {
                perPage: globalConfig.sliderNovedades.media1140,
                perMove: globalConfig.sliderNovedades.media1140,
            },
        },
        componentStyle: {
            hasBorder: false,
        },
    };
    var estilosFlechas = {
        position: {
            top: "-20%",
        },
    };
    return (React.createElement(React.Fragment, null,
        (titulo || descripcion || descripcionSeo || vinculo) && (React.createElement(ContenedorTitulo, null,
            (titulo || vinculo) && (React.createElement(TituloSeccion, { titulo: titulo, vinculo: vinculo })),
            descripcion && descripcion.meta && React.createElement("p", null, descripcion.meta),
            descripcionSeo && React.createElement("p", null, descripcionSeo))),
        React.createElement(DefaultSliderContenedor, { className: className },
            React.createElement(SliderManager, { productos: productos, settings: customSettings ? customSettings : defaultSettings, estilosFlechas: estilosFlechas }))));
};
export default DefaultSlider;
